import { currentLocale, tr } from '../services/i18n.js';

export function formatMatchLabel(match = {}) {
  const home = String(match.home_team || '').trim();
  const away = String(match.away_team || '').trim();
  if (!home && !away) return tr('Match à confirmer', 'Match TBC');
  if (!away) return home;
  if (!home) return away;
  return `${home} - ${away}`;
}

const FLAG_BY_FIFA_CODE = {
  ALG: '🇩🇿',
  ARG: '🇦🇷',
  AUS: '🇦🇺',
  AUT: '🇦🇹',
  BHR: '🇧🇭',
  BEL: '🇧🇪',
  BEN: '🇧🇯',
  BIH: '🇧🇦',
  BOL: '🇧🇴',
  BRA: '🇧🇷',
  BFA: '🇧🇫',
  CAN: '🇨🇦',
  CHI: '🇨🇱',
  CHN: '🇨🇳',
  CIV: '🇨🇮',
  CMR: '🇨🇲',
  COD: '🇨🇩',
  COL: '🇨🇴',
  CPV: '🇨🇻',
  CRC: '🇨🇷',
  CRO: '🇭🇷',
  CUW: '🇨🇼',
  CZE: '🇨🇿',
  DEN: '🇩🇰',
  ECU: '🇪🇨',
  EGY: '🇪🇬',
  ENG: '',
  EQG: '🇬🇶',
  ESP: '🇪🇸',
  FRA: '🇫🇷',
  GAB: '🇬🇦',
  GER: '🇩🇪',
  GHA: '🇬🇭',
  GNB: '🇬🇼',
  HAI: '🇭🇹',
  HON: '🇭🇳',
  IDN: '🇮🇩',
  IRN: '🇮🇷',
  IRQ: '🇮🇶',
  ITA: '🇮🇹',
  JAM: '🇯🇲',
  JPN: '🇯🇵',
  JOR: '🇯🇴',
  KOR: '🇰🇷',
  KUW: '🇰🇼',
  LBY: '🇱🇾',
  MAD: '🇲🇬',
  MLI: '🇲🇱',
  MAR: '🇲🇦',
  MEX: '🇲🇽',
  MOZ: '🇲🇿',
  NCL: '🇳🇨',
  NED: '🇳🇱',
  NGA: '🇳🇬',
  NOR: '🇳🇴',
  NZL: '🇳🇿',
  OMA: '🇴🇲',
  PAN: '🇵🇦',
  PAR: '🇵🇾',
  PER: '🇵🇪',
  POL: '🇵🇱',
  POR: '🇵🇹',
  PRK: '🇰🇵',
  QAT: '🇶🇦',
  RSA: '🇿🇦',
  KSA: '🇸🇦',
  SCO: '',
  SEN: '🇸🇳',
  SRB: '🇷🇸',
  SLV: '🇸🇻',
  SUR: '🇸🇷',
  SUI: '🇨🇭',
  SWE: '🇸🇪',
  TAH: '🇵🇫',
  TAN: '🇹🇿',
  TRI: '🇹🇹',
  TUN: '🇹🇳',
  TUR: '🇹🇷',
  UAE: '🇦🇪',
  UGA: '🇺🇬',
  UKR: '🇺🇦',
  URU: '🇺🇾',
  USA: '🇺🇸',
  UZB: '🇺🇿',
  VEN: '🇻🇪',
  WAL: '',
  ZAM: '🇿🇲',
  ZAF: '🇿🇦'
};

const FLAG_BY_TEAM_NAME = {
  algeria: '🇩🇿',
  algerie: '🇩🇿',
  argentina: '🇦🇷',
  argentine: '🇦🇷',
  australia: '🇦🇺',
  australie: '🇦🇺',
  austria: '🇦🇹',
  autriche: '🇦🇹',
  belgium: '🇧🇪',
  belgique: '🇧🇪',
  'bosnia and herzegovina': '🇧🇦',
  'bosnie herzégovine': '🇧🇦',
  'bosnie herzegovine': '🇧🇦',
  bolivia: '🇧🇴',
  bolivie: '🇧🇴',
  brazil: '🇧🇷',
  bresil: '🇧🇷',
  'burkina faso': '🇧🇫',
  cameroon: '🇨🇲',
  cameroun: '🇨🇲',
  'cape verde': '🇨🇻',
  'cap vert': '🇨🇻',
  'cabo verde': '🇨🇻',
  canada: '🇨🇦',
  chile: '🇨🇱',
  chili: '🇨🇱',
  china: '🇨🇳',
  chine: '🇨🇳',
  colombia: '🇨🇴',
  colombie: '🇨🇴',
  'costa rica': '🇨🇷',
  croatia: '🇭🇷',
  croatie: '🇭🇷',
  curacao: '🇨🇼',
  denmark: '🇩🇰',
  danemark: '🇩🇰',
  'dr congo': '🇨🇩',
  'rd congo': '🇨🇩',
  ecuador: '🇪🇨',
  equateur: '🇪🇨',
  egypt: '🇪🇬',
  egypte: '🇪🇬',
  england: '',
  angleterre: '',
  france: '🇫🇷',
  germany: '🇩🇪',
  allemagne: '🇩🇪',
  ghana: '🇬🇭',
  haiti: '🇭🇹',
  honduras: '🇭🇳',
  indonesia: '🇮🇩',
  indonesie: '🇮🇩',
  iran: '🇮🇷',
  iraq: '🇮🇶',
  irak: '🇮🇶',
  italy: '🇮🇹',
  italie: '🇮🇹',
  jamaica: '🇯🇲',
  jamaique: '🇯🇲',
  japan: '🇯🇵',
  japon: '🇯🇵',
  jordan: '🇯🇴',
  jordanie: '🇯🇴',
  mexico: '🇲🇽',
  mexique: '🇲🇽',
  morocco: '🇲🇦',
  maroc: '🇲🇦',
  netherlands: '🇳🇱',
  paysbas: '🇳🇱',
  'pays bas': '🇳🇱',
  nigeria: '🇳🇬',
  norway: '🇳🇴',
  norvege: '🇳🇴',
  'new zealand': '🇳🇿',
  'nouvelle zelande': '🇳🇿',
  oman: '🇴🇲',
  panama: '🇵🇦',
  paraguay: '🇵🇾',
  peru: '🇵🇪',
  perou: '🇵🇪',
  pologne: '🇵🇱',
  poland: '🇵🇱',
  portugal: '🇵🇹',
  qatar: '🇶🇦',
  'saudi arabia': '🇸🇦',
  'arabie saoudite': '🇸🇦',
  scotland: '',
  ecosse: '',
  senegal: '🇸🇳',
  serbia: '🇷🇸',
  serbie: '🇷🇸',
  'south africa': '🇿🇦',
  'afrique du sud': '🇿🇦',
  spain: '🇪🇸',
  espagne: '🇪🇸',
  switzerland: '🇨🇭',
  suisse: '🇨🇭',
  sweden: '🇸🇪',
  suede: '🇸🇪',
  tunisia: '🇹🇳',
  tunisie: '🇹🇳',
  turkey: '🇹🇷',
  turquie: '🇹🇷',
  ukraine: '🇺🇦',
  uruguay: '🇺🇾',
  uzbekistan: '🇺🇿',
  usa: '🇺🇸',
  'united states': '🇺🇸',
  'etats unis': '🇺🇸',
  'etatsunis': '🇺🇸',
  venezuela: '🇻🇪',
  wales: '',
  'pays de galles': ''
};

const FLAG_IMAGE_CODE_BY_FIFA_CODE = {
  ALG: 'dz',
  ARG: 'ar',
  AUS: 'au',
  AUT: 'at',
  BHR: 'bh',
  BEL: 'be',
  BEN: 'bj',
  BIH: 'ba',
  BOL: 'bo',
  BRA: 'br',
  BFA: 'bf',
  CAN: 'ca',
  CHI: 'cl',
  CHN: 'cn',
  CIV: 'ci',
  CMR: 'cm',
  COD: 'cd',
  COL: 'co',
  CPV: 'cv',
  CRC: 'cr',
  CRO: 'hr',
  CUW: 'cw',
  CZE: 'cz',
  DEN: 'dk',
  ECU: 'ec',
  EGY: 'eg',
  ENG: 'gb-eng',
  EQG: 'gq',
  ESP: 'es',
  FRA: 'fr',
  GAB: 'ga',
  GER: 'de',
  GHA: 'gh',
  GNB: 'gw',
  HAI: 'ht',
  HON: 'hn',
  IDN: 'id',
  IRN: 'ir',
  IRQ: 'iq',
  ITA: 'it',
  JAM: 'jm',
  JPN: 'jp',
  JOR: 'jo',
  KOR: 'kr',
  KUW: 'kw',
  LBY: 'ly',
  MAD: 'mg',
  MLI: 'ml',
  MAR: 'ma',
  MEX: 'mx',
  MOZ: 'mz',
  NCL: 'nc',
  NED: 'nl',
  NGA: 'ng',
  NOR: 'no',
  NZL: 'nz',
  OMA: 'om',
  PAN: 'pa',
  PAR: 'py',
  PER: 'pe',
  POL: 'pl',
  POR: 'pt',
  PRK: 'kp',
  QAT: 'qa',
  RSA: 'za',
  KSA: 'sa',
  SCO: 'gb-sct',
  SEN: 'sn',
  SRB: 'rs',
  SLV: 'sv',
  SUR: 'sr',
  SUI: 'ch',
  SWE: 'se',
  TAH: 'pf',
  TAN: 'tz',
  TRI: 'tt',
  TUN: 'tn',
  TUR: 'tr',
  UAE: 'ae',
  UGA: 'ug',
  UKR: 'ua',
  URU: 'uy',
  USA: 'us',
  UZB: 'uz',
  VEN: 've',
  WAL: 'gb-wls',
  ZAM: 'zm',
  ZAF: 'za'
};

const FLAG_IMAGE_CODE_BY_TEAM_NAME = {
  algeria: 'dz',
  algerie: 'dz',
  argentina: 'ar',
  argentine: 'ar',
  australia: 'au',
  australie: 'au',
  austria: 'at',
  autriche: 'at',
  belgium: 'be',
  belgique: 'be',
  'bosnia and herzegovina': 'ba',
  'bosnie herzégovine': 'ba',
  'bosnie herzegovine': 'ba',
  bolivia: 'bo',
  bolivie: 'bo',
  brazil: 'br',
  bresil: 'br',
  'burkina faso': 'bf',
  cameroon: 'cm',
  cameroun: 'cm',
  'cape verde': 'cv',
  'cap vert': 'cv',
  'cabo verde': 'cv',
  canada: 'ca',
  chile: 'cl',
  chili: 'cl',
  china: 'cn',
  chine: 'cn',
  colombia: 'co',
  colombie: 'co',
  'costa rica': 'cr',
  croatia: 'hr',
  croatie: 'hr',
  curacao: 'cw',
  denmark: 'dk',
  danemark: 'dk',
  'dr congo': 'cd',
  'rd congo': 'cd',
  ecuador: 'ec',
  equateur: 'ec',
  egypt: 'eg',
  egypte: 'eg',
  england: 'gb-eng',
  angleterre: 'gb-eng',
  france: 'fr',
  germany: 'de',
  allemagne: 'de',
  ghana: 'gh',
  haiti: 'ht',
  honduras: 'hn',
  indonesia: 'id',
  indonesie: 'id',
  iran: 'ir',
  iraq: 'iq',
  irak: 'iq',
  italy: 'it',
  italie: 'it',
  jamaica: 'jm',
  jamaique: 'jm',
  japan: 'jp',
  japon: 'jp',
  jordan: 'jo',
  jordanie: 'jo',
  mexico: 'mx',
  mexique: 'mx',
  morocco: 'ma',
  maroc: 'ma',
  netherlands: 'nl',
  paysbas: 'nl',
  'pays bas': 'nl',
  nigeria: 'ng',
  norway: 'no',
  norvege: 'no',
  'new zealand': 'nz',
  'nouvelle zelande': 'nz',
  oman: 'om',
  panama: 'pa',
  paraguay: 'py',
  peru: 'pe',
  perou: 'pe',
  pologne: 'pl',
  poland: 'pl',
  portugal: 'pt',
  qatar: 'qa',
  'saudi arabia': 'sa',
  'arabie saoudite': 'sa',
  scotland: 'gb-sct',
  ecosse: 'gb-sct',
  senegal: 'sn',
  serbia: 'rs',
  serbie: 'rs',
  'south africa': 'za',
  'afrique du sud': 'za',
  spain: 'es',
  espagne: 'es',
  switzerland: 'ch',
  suisse: 'ch',
  sweden: 'se',
  suede: 'se',
  tunisia: 'tn',
  tunisie: 'tn',
  turkey: 'tr',
  turquie: 'tr',
  ukraine: 'ua',
  uruguay: 'uy',
  uzbekistan: 'uz',
  usa: 'us',
  'united states': 'us',
  'etats unis': 'us',
  'etatsunis': 'us',
  venezuela: 've',
  wales: 'gb-wls',
  'pays de galles': 'gb-wls'
};

const INLINE_FLAG_SVG_BY_IMAGE_CODE = {
  // Drapeau de Saint-Georges : évite l'emoji subdivision Angleterre,
  // qui apparaît comme un simple drapeau noir sur certaines plateformes.
  'gb-eng': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 36"><rect width="60" height="36" fill="#fff"/><path fill="#ce1124" d="M25 0h10v36H25zM0 13h60v10H0z"/></svg>'
};

function flagImageSources(flagCode) {
  const inlineSvg = INLINE_FLAG_SVG_BY_IMAGE_CODE[flagCode];
  if (inlineSvg) {
    return {
      src: `data:image/svg+xml,${encodeURIComponent(inlineSvg)}`,
      srcset: ''
    };
  }
  return {
    src: `/flags/${flagCode}.svg`,
    srcset: ''
  };
}

export function teamFlag(teamName = '', teamCode = '') {
  const code = String(teamCode || '').trim().toUpperCase();
  const key = normalizeTeamName(teamName);
  if (!key || key.includes('confirmer') || key.includes('placeholder')) return '';
  const flagCode = (code && FLAG_IMAGE_CODE_BY_FIFA_CODE[code]) || FLAG_IMAGE_CODE_BY_TEAM_NAME[key];
  const emoji = (code && FLAG_BY_FIFA_CODE[code]) || FLAG_BY_TEAM_NAME[key] || '';
  if (!flagCode && !emoji) return '';
  const imageSources = flagCode ? flagImageSources(flagCode) : { src: '', srcset: '' };
  return {
    code: flagCode || '',
    emoji,
    src: imageSources.src,
    srcset: imageSources.srcset,
    alt: tr(`Drapeau ${String(teamName || code).trim()}`, `${String(teamName || code).trim()} flag`)
  };
}

export function formatKickoff(value, locale = currentLocale()) {
  if (!value) return tr('Date à confirmer', 'Date TBC');
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return tr('Date à confirmer', 'Date TBC');
  return d.toLocaleString(locale, {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function activeCompetitionLabel(competition = {}) {
  const name = competition.name || tr('Compétition', 'Competition');
  const country = competition.country ? ` · ${competition.country}` : '';
  return `${name}${country}`;
}

export function dataProviderLabel(provider = '') {
  const key = String(provider || '').trim().toLowerCase();
  if (key === 'fifa') return 'FIFA';
  if (key === 'manual') return tr('Saisie éditoriale', 'Editorial entry');
  return provider ? String(provider).trim() : tr('Source non renseignée', 'Unspecified source');
}

function normalizeTeamName(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
}
